module.exports = __webpack_public_path__ + "img/headportrait_7_icon.444f6c99.png";